import { type LigneMouvement, Nature, Section } from '@mairistem/comptabilite';
import type { ErrorField } from '@mairistem/liste';
import PROFIL_ECRITURE from '../../../../constants/mouvements/codeProfilEcritures';
import NATURE_PIECE from '../../../../constants/mouvements/naturePiece';
import NATURE_PIECE_ORIGINE from '../../../../constants/mouvements/naturePieceOrigine';
import { TYPE_BORDEREAU } from '../../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../../constants/mouvements/typePiece';
import CodeProduitLocalPanel from '../../panel/CodeProduitLocalPanel';
import CompteDeTiersPanel from '../../panel/CompteDeTiersPanel';
import CovidPanel from '../../panel/CovidPanel';
import MandatEmisApresPaiementPanel from '../../panel/InformationsRattachement/MandatEmisApresPaiementPanel';
import ProjetPanel from '../../panel/ProjetPanel';
import BaseProfilRattachement from '../Base/BaseProfilRattachement';

class ProfilEcritureInvesSansInfoInvEmiseApPaiementRecette extends BaseProfilRattachement {
	constructor(anneeExercice?: number) {
		super();
		this.code =
			PROFIL_ECRITURE.RECETTE.INVEST_SANS_INFO_INV_EMISE_APRES_PAIEMENT;
		this.typeBordereau = TYPE_BORDEREAU.RECETTE.ORDINAIRE;
		this.naturePiece = NATURE_PIECE.RECETTE.INVESTISSEMENT;
		this.typePiece = TYPE_PIECE.RECETTE.EMIS_APRES_PAIE;
		this.naturePieceOrigine = NATURE_PIECE_ORIGINE.TITRE.ENCAISSEMENT.CODE;
		this.exerRattachement = anneeExercice?.toString() ?? '';
		this.imputation.section = Section.INVESTISSEMENT;
		this.imputation.nature = Nature.REEL;
		this.idLigneOriginePes = 0;
		this.panels = [
			new CodeProduitLocalPanel(true),
			new CompteDeTiersPanel(),
			new CovidPanel(),
			new MandatEmisApresPaiementPanel(true),
			new ProjetPanel(),
		];
	}

	checkLigne(ligne: LigneMouvement): ErrorField[] {
		return [
			...super.checkLigne(ligne),
			...this.checkExerRattachementAnterieurOuEgal(ligne),
			...this.checkIdLigneOriginePesNul(ligne),
		];
	}
}

export default ProfilEcritureInvesSansInfoInvEmiseApPaiementRecette;
